<template>
  <div class="container-fluid">
    <div class="row">
      <template v-if="$can('read', 'footer-nag-bars')">
        <div
          v-if="inquiries"
          v-tooltip="{
            content: inquiriesTooltip,
            classes: ['nagbar-tooltip-theme', 'inquiries'],
          }"
          class="col text-center highlight highlight-inquiries cursor"
          :class="flashing.inquiries ? 'flashing' : ''"
          @click="listInquiries"
        >
          <div></div>
          <b>{{ formatNumber(inquiries.count) }}</b> Inquiries Awaiting Contact
        </div>
        <div v-else class="col text-center"></div>

        <div
          v-if="quoted"
          v-tooltip="{
            content: quotedTooltip,
            classes: ['nagbar-tooltip-theme', 'quoted'],
          }"
          class="col text-center highlight highlight-quoted cursor"
          @click="listQuoted"
        >
          <b>{{ formatNumber(quoted.count) }}</b> Quoted Awaiting Action
        </div>
        <div v-else class="col text-center"></div>

        <div
          v-if="invoiced"
          v-tooltip="{
            content: invoicedTooltip,
            classes: ['nagbar-tooltip-theme', 'invoiced'],
          }"
          class="col text-center highlight highlight-invoiced cursor"
          @click="listInvoiced"
        >
          <b>{{ formatNumber(invoiced.count) }}</b> Invoiced Awaiting Action
        </div>
        <div v-else class="col text-center"></div>

        <div
          v-if="rescheduling"
          class="col text-center highlight highlight-rescheduling cursor"
          @click="listRescheduling"
        >
          <b>{{ formatNumber(rescheduling) }}</b>
          Jobs Awaiting Rescheduling
        </div>
        <div v-else class="col text-right">
          <a href="/" target="_blank">BOLT</a>
          Admin UI
        </div>
      </template>
      <template v-else>
        <div class="col text-right">
          <a href="/" target="_blank">BOLT</a>
          Admin UI
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import EventBus from "../imports/event-bus";
import format from "../mixins/format";

export default {
  mixins: [format],

  data() {
    return {
      inquiries: false,
      quoted: false,
      invoiced: false,
      rescheduling: false,

      flashing: {
        inquiries: false,
      },
    };
  },

  computed: {
    inquiriesTooltip() {
      return this.makeTooltipHtml("inquiries");
    },
    quotedTooltip() {
      return this.makeTooltipHtml("quoted");
    },
    invoicedTooltip() {
      return this.makeTooltipHtml("invoiced");
    },
  },
  async mounted() {
    if (!this.$can("read", "footer-nag-bars")) {
      this.initialised = true;
      return;
    }

    await this.init(true);

    setInterval(async () => {
      if (this.$auth && this.$auth.check()) {
        await this.initInquiries(true);
      }
    }, 1000 * 60 * 5);

    EventBus.$on("job-updated", async () => {
      await this.init();
    });
    EventBus.$on("appointment-created", async () => {
      await this.init();
    });
    EventBus.$on("appointment-updated", async () => {
      await this.init();
    });
    EventBus.$on("appointment-deleted", async () => {
      await this.init();
    });

    this.initialised = true;
  },

  methods: {
    async init(flash) {
      const response = await this.$http.get("/jobs/follow-up-stats");
      this.inquiries = response.body.inquiries;
      this.quoted = response.body.quoted;
      this.invoiced = response.body.invoiced;

      const countResponse = await this.$http.get("/jobs/rescheduling-count");
      this.rescheduling = countResponse.body.count;

      if (flash) {
        this.flashInquiries();
      }
    },

    async initInquiries(flash) {
      const response = await this.$http.get("/jobs/inquiries-stats");
      this.inquiries = response.body;

      if (flash) {
        this.flashInquiries();
      }
    },

    flashInquiries() {
      if (this?.inquiries?.count > 0) {
        this.flashing.inquiries = true;
        setTimeout(() => {
          this.flashing.inquiries = false;
        }, 30000);
      }
    },

    listInquiries() {
      EventBus.$emit("list-inquiries");
    },
    listQuoted() {
      EventBus.$emit("list-quoted");
    },
    listInvoiced() {
      EventBus.$emit("list-invoiced");
    },
    listRescheduling() {
      EventBus.$emit("list-rescheduling");
    },

    makeTooltipHtml(type) {
      const data = this[type];
      const pending = data.details.count1 + data.details.count2 + data.details.count3;
      const formatedTotal = this.formatNumber(data.count);
      let formatedTotalInvoices = this.formatNumber(data.count_invoices);
      const allTotal = this.formatNumber(data.count + pending);

      let additional = "";
      switch (type) {
        case "inquiries":
          formatedTotalInvoices = pending;
          break;
        case "quoted":
          additional = `<div class="text-center"><b>${data.accepted}</b> Quote Accepted Jobs</div>`;
          type = "Quotes";
          break;
        case "invoiced":
          type = "Unpaid Invoices";
          break;
        default:
          break;
      }

      let html = "";
      html += '<div class="nagbar-tooltip">';
      html += `<div class="nagbar-total"><b>${formatedTotalInvoices}</b> Total ${type}</div>`;
      html += `<div class="footer-title">${type}</div>`;
      html += `<div class="text-center"><b>${allTotal}</b> Total Job Cards</div>`;
      html += additional;
      html += '<hr class="footer-hr">';
      html += "<div>Follow Up Stats</div>";
      html += '<div class="row">';
      html += '<div class="col">';
      html += `<div class="no-follow text-right capitalize"><br><b>${formatedTotal}</b> No Follow-up</div>`;
      html += "</div>";
      html += '<div class="col">';
      html += `<div><b>${pending}</b> Jobs Being Followed</div>`;
      html += `<div><b>${data.details.count1}</b> Follow-up 1</div>`;
      html += `<div><b>${data.details.count2}</b> Follow-up 2</div>`;
      html += `<div><b>${data.details.count3}</b> Follow-up 3+</div>`;
      html += "</div>";
      html += "</div>";
      html += "</div>";

      return html;
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@keyframes footer-stats-inquiries-toast {
  0% {
    color: #383e4b;
    background-color: #d8e8f5;
  }
  100% {
    color: #fff;
    background-color: #36a9e1;
  }
}

.container-fluid,
.col {
  height: 49px;
  line-height: 49px;
}

.col.highlight {
  transition: background-color 0.35s;
  font-size: 18px;

  b {
    color: #000000;
  }
}

.col.highlight-inquiries {
  color: #383e4b;
  background-color: #d8e8f5;

  &:hover {
    background-color: #84c3f6;
  }
}

.highlight-inquiries.flashing {
  animation-name: footer-stats-inquiries-toast;
  animation-duration: 1s;
  animation-direction: alternate;
  animation-iteration-count: infinite;
}

.col.highlight-quoted {
  color: #383e4b;
  background-color: #f8ca88;

  &:hover {
    background-color: #f7b75c;
  }
}

.col.highlight-invoiced {
  color: #383e4b;
  background-color: #b7e7cb;

  &:hover {
    background-color: #81e8ac;
  }
}

.col.highlight-rescheduling {
  color: #383e4b;
  background-color: #f5bcb8;

  &:hover {
    background-color: #f49992;
  }
}
</style>
